import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenHarvestCreateAction from './communityGardenHarvestCreate.action.json' with { type: 'json' }
import { communityGardenHarvestObject } from '../../communityGardenHarvestObject'

const communityGardenHarvestCreateDefinition = defineAction({
  ...communityGardenHarvestCreateAction,

  input: communityGardenHarvestObject
    .pick({
      id: true,
      communityGardenId: true,
      type: true,
      quantity: true,
      createdAt: true,
      updatedAt: true,
    })
    .extend({ id: communityGardenHarvestObject.shape.id.nullish() }),
  output: z.object({ id: communityGardenHarvestObject.shape.id }),
})

export default communityGardenHarvestCreateDefinition
